/**
 * Simulator Print Controller (EPIC-026.6 — D-26.6.D)
 *
 * Triggers the native `window.print()` from the "Exporter PDF" button. The
 * controller's element carries `data-print-scope="simulator"` or
 * `"comparator"` which is mirrored onto `<body>` while the print dialog is
 * open, so the `@media print` rules in `notamicro.css` can hide the right
 * pieces of chrome per page.
 */

import BaseController from "./base_controller.js";

export default class SimulatorPrintController extends BaseController {
  print() {
    const scope = this.element.dataset.printScope || "simulator";
    const previous = document.body.dataset.printScope;
    document.body.dataset.printScope = scope;
    const restore = () => {
      if (previous === undefined || previous === null || previous === "") {
        delete document.body.dataset.printScope;
      } else {
        document.body.dataset.printScope = previous;
      }
      window.removeEventListener("afterprint", restore);
    };
    window.addEventListener("afterprint", restore);
    window.print();
  }
}
